module.exports = __webpack_public_path__ + "img/12_drying_(white).ade639b0.svg";